export default "__VITE_ASSET__D5TuVk1W__"